/**
 *
 * Asynchronously loads the component for ParticipantInterventionsPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
